<template>
<v-card height="400">
    <v-container v-if="chart_data" fluid class="pa-0 ma-0">
        <v-card-text>
            <div class="pa-0">
                <v-icon large class="mr-1">multiline_chart</v-icon>
                <div class="ml-1">
                    <div class="subheading text-uppercase">Sales Volume</div>
                    <div class="heading grey--text">
                        {{from}}
                        <v-icon small>arrow_right_alt</v-icon>
                        {{until}}
                    </div>
                </div>
                <im-chart-details :data="chart_data"></im-chart-details>
            </div>
        </v-card-text>
        <v-divider class="mx-3" />
        <v-card-text>
            <im-bar-chart :data="chart_data" :options="chart_options" :height="300" />
        </v-card-text>
    </v-container>
    <v-container v-else fill-height align-center fluid class="pa-0 ma-0">
        <v-card-text>
            <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular :size="75" color="primary" indeterminate />
            </div>
        </v-card-text>
    </v-container>
</v-card>
</template>

<script>
import BarChart from '../BarChart.vue'
import ChartDetails from '../ChartDetails.vue'

export default {

    components: {
        'im-bar-chart': BarChart,
        'im-chart-details': ChartDetails
    },

    props: {
        url: String,
        from: String,
        until: String
    },

    watch: {
        from: function () {
            this.getChart();
        },
        until: function () {
            this.getChart();
        }
    },

    methods: {
        getChart() {

            this.chart_data = null;
            this.chart_options = null;

            this.$axios.get(this.url + "/daily-sales-volume", {
                    params: {
                        from: this.from,
                        until: this.until
                    }
                })
                .then(response => {

                    let max_sales = response.data.max_sales;
                    let max_bookings = response.data.max_bookings;

                    this.chart_data = {
                        labels: response.data.labels,
                        datasets: [
                            {
                                label: 'Sales (€)',
                                type: 'line',
                                borderColor: "#00B0FF",
                                backgroundColor: "#00B0FF",
                                yAxisID: 'sales',
                                fill: false,
                                pointRadius: 0,
                                data: response.data.datasets.sales
                                },
                            {
                                label: 'Reservations',
                                type: 'bar',
                                borderColor: "#00E676",
                                backgroundColor: "#00E676",
                                yAxisID: 'reservations',
                                fill: false,
                                data: response.data.datasets.bookings
                                }
                            ]
                    };

                    this.chart_options = {
                        responsive: true,
                        maintainAspectRatio: false,
                        fill: false,
                        tooltips: {
                            mode: 'index'
                        },
                        legend: {
                            position: 'bottom'
                        },
                        scales: {
                            xAxes: [{
                                barPercentage: 0.5
                                }],
                            yAxes: [
                                {
                                    id: 'sales',
                                    type: 'linear',
                                    position: 'left',
                                    ticks: {
                                        min: 0,
                                        max: Math.ceil(max_sales / 500) * 500
                                    }
                                    },
                                {
                                    id: 'reservations',
                                    type: 'linear',
                                    position: 'right',
                                    gridLines: {
                                        color: "rgba(0, 0, 0, 0)",
                                    },
                                    ticks: {
                                        min: 0,
                                        max: (Math.ceil(max_bookings / 5) * 5) * 4
                                    }
                                    }
                                ]
                        }
                    };

                });
        }
    },

    created() {
        this.getChart();
    },

    data() {
        return {
            chart_data: null,
            chart_options: null
        }
    }
}
</script>
